import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../appServices/AuthService/auth.service';
import { HelperService } from '../../appServices/HelperService/helper.service';

@Injectable({
    providedIn: 'root'
})

export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService,private helperService: HelperService,private router: Router,) { }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.authService.isLoggedIn()) { 
            const allowedRolesArray = route.data['allowedRoles'];
            const allowedRoles = Array.isArray(allowedRolesArray) ? allowedRolesArray[0] : allowedRolesArray;
            var roleAccessResult = JSON.parse(this.helperService.decryption(localStorage.getItem('roleAccessResult'))); 
            const caseFollowUpRead = roleAccessResult.some((x:any) => x.com_page_title === allowedRoles && x.cac_isAllowed === true);
            if(caseFollowUpRead){
                return true;
            }else{
                return this.router.parseUrl('/Error');
            }
        }
        this.authService.logout();
        return false;
    }
}

